import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { TokenDetails } from '@app/core/models/token-detail.model';
@Injectable({
  providedIn: 'root',
})
export class MFAService {
  constructor(private http: HttpClient) {}

  /* API call POST method to reset password */
  getAuthTokenApi(body) {
    return this.http.post<TokenDetails>('oauth/token/', body).pipe(
      map((data) => {
        return data;
      })
    );
  }

  /**
   * Get enrolled authenticators
   */
  getAllUsers() {
    return this.http.get<TokenDetails>(`/users`);
  }

  /**
   * Get mfa associated details for enrollment
   */
  enrollAuthenticatorApi(body) {
    return this.http.post(`mfa/associate`, body).pipe(
      map((data) => {
        return data;
      })
    );
  }
  /**
   * Get enrolled authenticators
   */
  getEnrolledAuthApi(userID) {
    return this.http.get<TokenDetails>(`/users/${userID}/authentication-methods`);
  }
}
